import { Button } from "@/components/ui/button";
import { ArrowLeft, ArrowRight, RotateCcw } from "lucide-react";
import { Link } from "react-router-dom";

export function BookingNavigation({ step, loading, pricing, onBack, onNext, onSubmit, onStartOver }) {
  return (
    <div className="flex flex-col gap-4 mt-8 pt-6 border-t">
      <div className="flex justify-between">
        {step > 1 ? (
          <Button 
            variant="outline" 
            onClick={onBack}
            data-testid="back-btn"
            className="rounded-full h-12 px-6"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back
          </Button>
        ) : (
          <Link to="/">
            <Button 
              variant="outline" 
              data-testid="back-home-btn"
              className="rounded-full h-12 px-6"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
          </Link>
        )}
        {step < 5 ? (
          <Button 
            onClick={onNext}
            data-testid="next-btn"
            className="rounded-full bg-green-600 text-white hover:bg-green-700 h-12 px-8"
          >
            Next
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        ) : (
          <Button 
            onClick={onSubmit}
            disabled={loading}
            data-testid="submit-booking-btn"
            className="rounded-full bg-green-600 text-white hover:bg-green-700 h-12 px-8"
          >
            {loading ? "Processing..." : `Pay $${pricing.total_due_now.toFixed(2)} Deposit`}
          </Button>
        )}
      </div>
      
      {step > 1 && (
        <div className="text-center">
          <Button 
            variant="ghost" 
            onClick={onStartOver}
            data-testid="start-over-btn"
            className="text-muted-foreground hover:text-foreground"
          >
            <RotateCcw className="w-3 h-3 mr-1" />
            Start Over
          </Button>
        </div>
      )}
    </div>
  );
}
